import { useState } from "react";
import { uploadCertifications } from "../services/api";
import { getErrorAlertMessage } from "../utils/errors";

export function CertificationUploadPanel() {
  const [csvText, setCsvText] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState<{ type: "info" | "error"; text: string } | null>(null);

  async function handleSubmit() {
    if (!csvText.trim()) {
      setMessage({ type: "error", text: "Paste certification CSV content before uploading." });
      return;
    }
    setIsUploading(true);
    setMessage(null);
    try {
      const result = await uploadCertifications(csvText);
      setMessage({
        type: "info",
        text: `Upload complete. Created ${result.created}, updated ${result.updated}, deleted ${result.deleted}, skipped ${result.skipped}.`,
      });
      setCsvText("");
    } catch (err) {
      setMessage({ type: "error", text: getErrorAlertMessage("upload certifications", err) });
    } finally {
      setIsUploading(false);
    }
  }

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const [file] = event.target.files ?? [];
    if (!file) return;
    file.text().then(setCsvText).catch(() => {
      setMessage({ type: "error", text: "Failed to read selected file." });
    });
  }

  return (
    <div className="panel">
      <h2>Certification Upload</h2>
      <p className="helper-text">
        Upload a CSV in the same format as <code>certs.csv</code>. Existing certification entries will be updated; entries
        with Action=DELETE will be removed.
      </p>
      <label>
        Select file
        <input type="file" accept=".csv,text/csv" onChange={handleFileChange} />
      </label>
      <label>
        Or paste CSV data
        <textarea
          rows={8}
          value={csvText}
          onChange={(event) => setCsvText(event.target.value)}
          placeholder="Paste CSV content here..."
        />
      </label>
      <div className="form-actions">
        <button type="button" className="primary" onClick={handleSubmit} disabled={isUploading}>
          {isUploading ? "Uploading…" : "Upload Certifications"}
        </button>
      </div>
      {message && <div className={`alert ${message.type}`}>{message.text}</div>}
    </div>
  );
}

